import { observable, runInAction } from 'mobx';
import { SearchModel } from 'pages/model';
import { CustomerSurveyReportModel, IReportVisitCustomerSRServices, ReportAverageRatingOverTimeModel, ReportDetailRateVisitCustomerModel, ReportGeneralRateVisitCustomerModel, ReportRatioRatingModel, ReportUnsatifiedModel, WarrantyActiveReportModel, WorkStatusReportModel } from 'services/Main/reportVisitCustomerSR';
import { DataResponse } from 'services/response';
import { PAGE_SIZE_DEFAULT } from 'utils/constants';

export type ReportVisitCustomerSRStore = {
  // Báo cáo chi tiết đánh giá khách hàng ghé thăm sr
  reportCTKHSR: DataResponse<Array<ReportDetailRateVisitCustomerModel>>

  // Báo cáo tổng hợp đánh giá khách hàng ghé thăm sr
  reportTHDGKH: DataResponse<Array<ReportGeneralRateVisitCustomerModel>>
  // data Báo cáo tỷ lệ đánh giá trên tổng lượt ghé thăm
  reportTLDTTTLGT: DataResponse<Array<ReportRatioRatingModel>>
  // data Báo cáo điểm trung bình đánh giá theo thời gian
  reportDDGTBTTG: DataResponse<Array<ReportAverageRatingOverTimeModel>>

  reportUnsatified: DataResponse<Array<ReportUnsatifiedModel>>

  companyBySaleOrg: DataResponse<string>

  // báp cáp tổng hợp kích hoạt bảo hành
  reportWarrantyActive: DataResponse<WarrantyActiveReportModel[]>


  customerSurveyRP: DataResponse<CustomerSurveyReportModel[]>
  workStatusRP: DataResponse<WorkStatusReportModel[]>

  dataSearch: SearchModel

};

export interface IProjectManagementPresenter {
  createStore(): ReportVisitCustomerSRStore;
  // Lấy data table báo cáo chi tiết đánh giá khách hàng
  getDataReportCTKHGTSR(store: ReportVisitCustomerSRStore, dataSearch: Object): Promise<void>
  // ------------------------------------------------------------------------------------------------
  // Lấy data table báo cáo tổng hợp đánh giá khách hàng
  getDataReportTHDGKH(store: ReportVisitCustomerSRStore, dataSearch: Object): Promise<void>
  // ------------------------------------------------------------------------------------------------
  // Lấy data Báo cáo tỷ lệ đánh giá trên tổng lượt ghé thăm
  getDataReportTLDGTTLGT(store: ReportVisitCustomerSRStore, dataSearch: Object): Promise<void>

  // Lấy data Báo cáo điểm trung bình đánh giá theo thời gian
  getDataReportDDGTBTTG(store: ReportVisitCustomerSRStore, dataSearch: Object): Promise<void>

  getDataReportUnsatified(store: ReportVisitCustomerSRStore, dataSearch: Object): Promise<void>

  getCompanyBySaleOrg(store: ReportVisitCustomerSRStore, saleOrg: string): Promise<void>

  // Reports/report-tonghopbaohanh Báo cáo tổng hợp kích hoạt bảo hành
  getDataReportWarrantyActive(store: ReportVisitCustomerSRStore, data: object): Promise<void>

  // Lấy data báo cáo khảo sát ý kiến khách hàng
  getDataCustomerSurveyReport(store: ReportVisitCustomerSRStore, data: object): Promise<void>

  // Báo cáo khảo sát ý kiến khách hàng
  getWorkStatusReport(store: ReportVisitCustomerSRStore, data: object): Promise<void>


  // Export excel =================================================================
  exportExcelBC1(data: object): Promise<void>
  exportExcelBC2(data: object): Promise<void>
  exportExcelBC3(data: object): Promise<void>
  exportExcelBC4(data: object): Promise<void>
  exportExcelBC5(data: object): Promise<void>

  exportExcelCustomerSurvey(data: object): Promise<void>
  exportExcelWorkStatus(data: object): Promise<void>




  // Lưu lại state trong màn báo cáo =================================
  // tổng hợp kích hoạt bảo hành trong (Bảo hành - khiếu nại) ========
  handleSetDataSearch(store: ReportVisitCustomerSRStore, state: SearchModel): Promise<void>
}

export function createReportVisitCustomerSRPresenter({ reportVisitCustomerSRServices }: { reportVisitCustomerSRServices: IReportVisitCustomerSRServices }): IProjectManagementPresenter {
  return {
    createStore: (): ReportVisitCustomerSRStore =>
      observable({
        reportCTKHSR: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        reportTHDGKH: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        reportTLDTTTLGT: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        reportDDGTBTTG: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        reportUnsatified: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        companyBySaleOrg: {
          data: '',
          message: '',
          isSuccess: false,
        },
        reportWarrantyActive: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },


        dataSearch: {
          paging: {
            pageSize: PAGE_SIZE_DEFAULT,
            pageIndex: 1,
            orderBy: undefined,
            orderByDesc: undefined,
          },
          config: 1
        },

        customerSurveyRP: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        workStatusRP: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        }
      }),
    getDataReportCTKHGTSR: async (store, data) => {
      try {
        const result = await reportVisitCustomerSRServices.getDataReportCTKHSR(data);
        runInAction(() => {
          store.reportCTKHSR.data = result.data;
          store.reportCTKHSR.isSuccess = result.isSuccess;
          store.reportCTKHSR.message = result.message;
          store.reportCTKHSR.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // --------------------------------------------------------------------------------------------------------------------
    getDataReportTHDGKH: async (store, data) => {
      try {
        const result = await reportVisitCustomerSRServices.getDataReportTHDGKH(data);
        runInAction(() => {
          store.reportTHDGKH.data = result.data;
          store.reportTHDGKH.isSuccess = result.isSuccess;
          store.reportTHDGKH.message = result.message;
          store.reportTHDGKH.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // --------------------------------------------------------------------------------------------------------------------
    getDataReportTLDGTTLGT: async (store, data) => {
      try {
        const result = await reportVisitCustomerSRServices.getDataReportTLDGTTLGT(data);
        runInAction(() => {
          store.reportTLDTTTLGT.data = result.data;
          store.reportTLDTTTLGT.isSuccess = result.isSuccess;
          store.reportTLDTTTLGT.message = result.message;
          store.reportTLDTTTLGT.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // --------------------------------------------------------------------------------------------------------------------
    // Lấy data Báo cáo điểm trung bình đánh giá theo thời gian
    getDataReportDDGTBTTG: async (store, data) => {
      try {
        const result = await reportVisitCustomerSRServices.getDataReportDDGTBTTG(data);
        runInAction(() => {
          store.reportDDGTBTTG.data = result.data;
          store.reportDDGTBTTG.isSuccess = result.isSuccess;
          store.reportDDGTBTTG.message = result.message;
          store.reportDDGTBTTG.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Lấy data Báo cáo điểm trung bình đánh giá theo thời gian
    getDataReportUnsatified: async (store, data) => {
      try {
        const result = await reportVisitCustomerSRServices.getDataReportUnsatified(data);
        runInAction(() => {
          store.reportUnsatified.data = result.data;
          store.reportUnsatified.isSuccess = result.isSuccess;
          store.reportUnsatified.message = result.message;
          store.reportUnsatified.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getCompanyBySaleOrg: async (store, saleOrg) => {
      try {
        const result = await reportVisitCustomerSRServices.getCompanyBySaleOrg(saleOrg);
        runInAction(() => {
          store.companyBySaleOrg.data = result.data;
          store.companyBySaleOrg.isSuccess = result.isSuccess;
          store.companyBySaleOrg.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getDataReportWarrantyActive: async (store, data) => {
      try {
        const result = await reportVisitCustomerSRServices.getDataReportWarrantyActive(data);
        runInAction(() => {
          store.reportWarrantyActive.data = result.data;
          store.reportWarrantyActive.isSuccess = result.isSuccess;
          store.reportWarrantyActive.message = result.message;
          store.reportWarrantyActive.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // Khảo sát ý kiến khách hàng
    getDataCustomerSurveyReport: async (store, data) => {
      try {
        const result = await reportVisitCustomerSRServices.getDataCustomerSurveyReport(data);
        runInAction(() => {
          store.customerSurveyRP.data = result.data;
          store.customerSurveyRP.isSuccess = result.isSuccess;
          store.customerSurveyRP.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // Báo cáo khảo sát ý kiến khách hàng
    getWorkStatusReport: async (store, data) => {
      try {
        const result = await reportVisitCustomerSRServices.getWorkStatusReport(data);
        runInAction(() => {
          store.workStatusRP.data = result.data;
          store.workStatusRP.isSuccess = result.isSuccess;
          store.workStatusRP.message = result.message;
          store.workStatusRP.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },



    // =================================================================================================
    exportExcelBC1: async (data) => {
      try {
        await reportVisitCustomerSRServices.exportExcelBC1(data);
      } catch (error) {
        console.log(error);
      }
    },
    // =================================================================================================
    exportExcelBC2: async (data) => {
      try {
        await reportVisitCustomerSRServices.exportExcelBC2(data);
      } catch (error) {
        console.log(error);
      }
    },
    // =================================================================================================
    exportExcelBC3: async (data) => {
      try {
        await reportVisitCustomerSRServices.exportExcelBC3(data);
      } catch (error) {
        console.log(error);
      }
    },
    // =================================================================================================
    exportExcelBC4: async (data) => {
      try {
        await reportVisitCustomerSRServices.exportExcelBC4(data);
      } catch (error) {
        console.log(error);
      }
    },
    // =================================================================================================
    exportExcelBC5: async (data) => {
      try {
        await reportVisitCustomerSRServices.exportExcelBC5(data);
      } catch (error) {
        console.log(error);
      }
    },
    exportExcelCustomerSurvey: async (data) => {
      try {
        await reportVisitCustomerSRServices.exportExcelCustomerSurvey(data);
      } catch (error) {
        console.log(error);
      }
    },
    exportExcelWorkStatus: async (data) => {
      try {
        await reportVisitCustomerSRServices.exportExcelWorkStatus(data);
      } catch (error) {
        console.log(error);
      }
    },


    // tổng hợp kích hoạt bảo hành trong (Bảo hành - khiếu nại) ========
    handleSetDataSearch: async (store, data) => {
      try {
        store.dataSearch = data
      } catch (error) {
        console.log(error);
      }
    },
  };
}
